/**
 * Punto de entrada de la aplicación. De momento solo hay una pantalla —la del caso—,
 * porque la portada, el caso diario y el selector de dificultad son la etapa 4
 * (MON-61). El `key` reinicia el estado de la partida cuando cambia el caso.
 */

import { CasePage } from './case/CasePage';
import { caseKey, useCase } from './case/useCase';

export function App() {
  const loaded = useCase(window.location.search);
  return <CasePage key={caseKey(loaded.setup)} loaded={loaded} />;
}
